import StorageUtils from "./StorageUtils"
import CommonUtils from "./CommonUtils"
import Constants from "./Constants"

class BrandUtils {
    static initPageBrand() {
        let brandName = StorageUtils.retrieveStringFromLocal(Constants.Storage.BRAND_NAME)
        if(CommonUtils.isNotEmpty(brandName)) {
            try {
                document.title = brandName
            } catch(e) {}
        }
    }

    static refreshPageBrand(brandInfo) {
        if(brandInfo && CommonUtils.isNotEmpty(brandInfo.brandName)) {
          try {
            document.title = brandInfo.brandName
            StorageUtils.storeStringToLocal(Constants.Storage.BRAND_NAME, brandInfo.brandName)
          } catch(e) {}
        }
    }

    static getCachedBrandName() {
        return StorageUtils.retrieveStringFromLocal(Constants.Storage.BRAND_NAME)
    }
}

export default BrandUtils


// WEBPACK FOOTER //
// ./src/utils/BrandUtils.js